<template>
<div>

<compFormEdit ref="formbase" class="margin-layout" :formdata="getBase" v-model="formData"  :labelWidth="120"></compFormEdit>
  <vButtonGroup class="text-right">
          <vButton @click="submit" theme="primary">{{$t('global.modal.confirm', { defaultValue: "确定" })}}</vButton>
          <vButton @click="cancel">{{$t('global.common.cancel', { defaultValue: "取消" })}}</vButton>
  </vButtonGroup>
  <vLoading loading size="large" transfer v-if="loading"></vLoading>
</div>
</template>

<script>
import {
    HttpSaveSystemPort,
    HttpSystemPortGetOne
} from "@/service/basicdata";
export default {
  props: ["activeid","type"],
  created() {
    this.getDetail();
  },
  data() {
    return {
      loading: false,
      id:  this.activeid,
      formData: {
      },
      required: [
        {
          required: true,
          message: "该信息不能为空,请填写"
        }
      ],
    };
  },
  computed: {
      isQuery() {
          return this.type === "query";
      },
      isAdd() {
        return this.type === 'add'
      },
     getBase() {
			return [{
              label: this.$t('fbb.basic.port_name',{defaultValue:'港口名称'}),
              key: "title",
              span:24,
              query:this.isQuery,
              tag:'vInput',
              },{
              label: this.$t('fbb.basic.port_code',{defaultValue:'港口Code'}),
              key: "code",
              span:24,
              query:this.isQuery,
              tag:'vInput',
              },{
              label: this.$t('fbb.accountmanage.description',{defaultValue:'描述'}),
              key: "description",
              query:this.isQuery,
              span:24,
              required:false,
              tag:'vTextarea',
              }
      ];
     }
        
  },
  methods: {
      getDetail() {
      if (this.isAdd) return;
      this.loading = true;
      if(this.id){
          HttpSystemPortGetOne({ id: this.id }).then(res => {
					
          this.formData = res.data;
          	this.loading = false;
				}).catch(err => {
					this.loading = false;
					this.$VMessage.error(err.message);
				})
      }
    },
    
    async submit(){
        const valid = await this.$refs.formbase.validate();
        if (!valid) return;
        this.loading = true;
        HttpSaveSystemPort({
         ...this.formData
        })
          .then(res => {
            this.loading = false;
            this.$VMessage.success(this.$t('fbb.logistics.cost_add_success', { defaultValue: '添加成功' }));
            this.success();
          }, err => {
            this.loading = false;
                this.$VMessage.error(err.message)
            });
    },
   
    success() {
      this.$emit("on-close");
      this.$emit("on-update");
      this.$emit("refreshPage");
    },
    cancel() {
      this.$emit("on-close");
    }
  }
};
</script>
